import React from "react";
import { FaLightbulb, FaRocket } from "react-icons/fa";
import { MdOutlineDesignServices } from "react-icons/md";
import { HiBolt } from "react-icons/hi2";
import { BsClipboardCheck } from "react-icons/bs";
import "./IOSProcessSection.css";

const IOSProcessSection = () => {
    return (
        <>
            <section className="ios-process-section">

                {/* Blur BG */}
                <div className="process-blur blur-one"></div>
                <div className="process-blur blur-two"></div>

                <div className="process-container">

                    {/* Heading */}
                    <div className="process-heading">
                        <span>OUR iOS DEVELOPMENT PROCESS</span>

                        <h2>
                            Turning Your App Idea Into
                            <span> A Premium iPhone Experience</span>
                        </h2>

                        <p>
                            We follow a streamlined iOS app development process
                            focused on design, performance and scalability.
                        </p>
                    </div>

                    {/* Timeline */}
                    <div className="process-timeline">

                        {/* Step 01 */}
                        <div className="process-step">
                            <div className="step-number">01</div>

                            <div className="step-card">
                                <div className="step-icon">
                                    <FaLightbulb />
                                </div>

                                <h3>Idea & Strategy</h3>

                                <p>
                                    We analyze your app idea, target audience and
                                    define the perfect roadmap for success.
                                </p>
                            </div>
                        </div>

                        {/* Step 02 */}
                        <div className="process-step">
                            <div className="step-number">02</div>

                            <div className="step-card">
                                <div className="step-icon">
                                    <MdOutlineDesignServices />
                                </div>

                                <h3>UI/UX Design</h3>

                                <p>
                                    Stunning iOS-focused interfaces crafted with
                                    Apple Human Interface Guidelines.
                                </p>
                            </div>
                        </div>

                        {/* Step 03 */}
                        <div className="process-step">
                            <div className="step-number">03</div>

                            <div className="step-card">
                                <div className="step-icon">
                                    <HiBolt />
                                </div>

                                <h3>Swift Development</h3>

                                <p>
                                    Building blazing-fast iOS apps using Swift,
                                    SwiftUI and modern Apple technologies.
                                </p>
                            </div>
                        </div>

                        {/* Step 04 */}
                        <div className="process-step">
                            <div className="step-number">04</div>

                            <div className="step-card">
                                <div className="step-icon">
                                    <BsClipboardCheck />
                                </div>

                                <h3>Testing & QA</h3>

                                <p>
                                    Rigorous testing for performance, security
                                    and bug-free user experiences.
                                </p>
                            </div>
                        </div>

                        {/* Step 05 */}
                        <div className="process-step">
                            <div className="step-number">05</div>

                            <div className="step-card">
                                <div className="step-icon">
                                    <FaRocket />
                                </div>

                                <h3>Launch & Growth</h3>

                                <p>
                                    App Store deployment, optimization and
                                    post-launch support for scaling.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
};

export default IOSProcessSection;